import React, { useState, useEffect } from "react";
import { Button, Grid, Collapse } from "@mui/material";
import { NotificationManager } from "react-notifications";
import { ReviewInvoice, GenerateInvoice ,SendInvoiceEmail} from "../../services/InvoiceService";
import UserService from "../../../globel-constants/UserService";
import ApplyPaymentsDialog from "./ApplyPaymentsDialog";

const EditInvoiceActions = ({ invoiceNumber, invoiceData, orderNumber, expanded }) => {
  const accountNumber = (invoiceData?.accountNumber || "").trim();
  const [loggedInUser, setLoggedInUser] = useState();
  const [isApplyPaymentsDialogOpen, setApplyPaymentsDialogOpen] =
    useState(false);

  useEffect(() => {
    let user = UserService.getUserInfoFromLocalStorage();
    setLoggedInUser(user);
  }, []);

  const handleReviewInvoice = async () => {
    if (invoiceData.reviewedBy2 && invoiceData.reviewedBy2 !== "") {
      NotificationManager.success("Invoice Reviewed already");
      return;
    }
    try {
      await ReviewInvoice({
        invoiceNumber: invoiceNumber,
        reviewedBy: loggedInUser.operator,
      });
      NotificationManager.success("Invoice Reviewed successfully");
      window.location.reload();
    } catch (error) {
      NotificationManager.error("Error updating Invoice " + error.message);
    }
  };

    const sendEmail = async () => {
    
    try {
      await SendInvoiceEmail(invoiceNumber);
      NotificationManager.success("Invoice Email sent successfully");
      window.location.reload();
    } catch (error) {
      NotificationManager.error("Error sending Invoice email" + error.message);
    }
  };

  const handleAdditionalInvoice = () => {
    NotificationManager.success("Coming Soon.");
    console.log("Additional Invoice:", invoiceNumber);
  };

    const handleSendInvoiceEmail = () => {   
    console.log("handleSendInvoiceEmail:", invoiceNumber);
    sendEmail();
  };

  const handleNewInvoice = async () => {
    // NotificationManager.success("Coming Soon.");
    createInvoice();
    console.log("New Invoice:", invoiceNumber);
  };

  const createInvoice = async () => {
    try {
      let response = await GenerateInvoice({
        invoiceNumber: orderNumber.toString(),
        reviewedBy: loggedInUser.operator,
      });
      
      const data = await response.json();
      NotificationManager.success(
        "Invoice created successfully" + " Invoice Number: " + data.results
      );
      window.open(`/vlp/invoices/edit/${data.results}`, "_blank");
    } catch (error) {
      NotificationManager.error("Error updating Invoice " + error.message);
    }
  };

  const handleApplyPayments = () => {
    setApplyPaymentsDialogOpen(true);
  };

  const handleCloseApplyPaymentsDialog = () => {
    setApplyPaymentsDialogOpen(false);
  };

  const handleApplyPaymentsSubmit = () => {
    handleCloseApplyPaymentsDialog();
  };

  return (
    <>
      {/* Same collapsible Actions panel as Edit Lab Order (LabOrderActions) */}
      <Collapse in={expanded}>
        {/* Buttons are grouped by action type; each group shares one color (same scheme as Edit Lab Order). */}
        <Grid container spacing={2} sx={{ p: "10px" }}>
          {/* Create */}
          <Grid item sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            <Button variant="outlined" size="small" color="success" onClick={handleNewInvoice}>
              New Invoice
            </Button>
            <Button variant="outlined" size="small" color="success" onClick={handleAdditionalInvoice}>
              Additional Invoice
            </Button>
          </Grid>

          {/* Send */}
          <Grid item sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            <Button variant="outlined" size="small" color="secondary" onClick={handleSendInvoiceEmail}>
              Send Invoice Email
            </Button>
          </Grid>

          {/* Other */}
          <Grid item sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            <Button variant="outlined" size="small" color="warning" onClick={handleReviewInvoice}>
              Review Invoice
            </Button>
            <Button variant="outlined" size="small" color="warning" onClick={handleApplyPayments}>
              Apply Payments
            </Button>
            <Button
              variant="outlined"
              size="small"
              color="warning"
              onClick={() => window.open(`/vlp/quotes?account=${encodeURIComponent(accountNumber)}`, "_blank")}
              disabled={!accountNumber}
            >
              Jump To Quotes
            </Button>
          </Grid>
        </Grid>
      </Collapse>

      {/* Apply Payments Dialog */}
      <ApplyPaymentsDialog
        open={isApplyPaymentsDialogOpen}
        onClose={handleCloseApplyPaymentsDialog}
        onApply={handleApplyPaymentsSubmit}
      />
    </>
  );
};

export default EditInvoiceActions;
